import FrontChat from './FrontChat';

export default FrontChat;
